// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"f08f88f6","842":"8df647c5"}[chunkId] + ".chunk.js";
};